/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.1227 6.115c1.3151-1.315 3.4472-1.315 4.7622 0 1.3151 1.3151 1.3151 3.4472 0 4.7623-1.315 1.315-3.4471 1.315-4.7622 0-1.315-1.315-1.315-3.4472 0-4.7622Zm3.4016 1.3607c-.5636-.5636-1.4773-.5636-2.0409 0-.5636.5636-.5636 1.4773 0 2.041.5636.5635 1.4773.5635 2.0409 0 .5636-.5637.5636-1.4774 0-2.041Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.307 1.693C20.2358-.3782 14.995-1.2863 9.7885 3.3667 5.2545 2.4542 1.9694 4.7724.8127 6.186l-.5513.674 3.2335 3.2334a54.7463 54.7463 0 0 0-.2.2438c-1.261 1.5463-1.9812 2.6177-2.2579 3.1711l-.3101.6203 9.1445 9.1444.6202-.3101c.5534-.2767 1.6248-.9969 3.1711-2.2579.0799-.0651.1611-.1318.2438-.2l3.2179 3.2179.6739-.5514c1.4108-1.1543 3.7227-4.4287 2.8248-8.9487C25.2877 9.0126 24.3797 3.7657 22.307 1.693Zm-3.4126 14.2854c-1.3216 1.2901-2.4957 2.3735-3.5197 3.2737l1.8145 1.8144c.8267-.988 1.7775-2.7601 1.7052-5.0881ZM2.9178 6.7952c.9923-.8302 2.7754-1.7856 5.118-1.7043C6.7396 6.4185 5.6515 7.5975 4.748 8.6253l-1.83-1.8301Zm18.0286-3.7416C19.7152 1.8226 15.2975.5389 10.4015 5.4349c-2.566 2.566-4.386 4.6111-5.6154 6.1185-.8116.9953-1.3519 1.7394-1.6786 2.2347l7.1045 7.1045c.4953-.3267 1.2394-.867 2.2347-1.6786 1.5074-1.2293 3.5526-3.0494 6.1186-5.6154 4.8959-4.896 3.6122-9.3137 2.3811-10.5449ZM2.2377 17.0001l-.6803.6803C.3245 18.9133 0 20.2806 0 21.3371c0 .5198.0777.9609.1563 1.2751a4.498 4.498 0 0 0 .1119.379 3.2326 3.2326 0 0 0 .0557.149l.0052.0126.002.0049.001.0022.0004.0009s.0004.001.8847-.378l-.8843.379.1516.3537.3537.1516.379-.8843c-.379.8843-.378.8847-.378.8847l.001.0004.002.0009.005.0021.0126.0052c.0096.0039.0216.0088.036.0143.0286.0111.0665.0253.113.0414.093.0322.2212.0724.379.1119A5.29 5.29 0 0 0 2.663 24c1.0565 0 2.4239-.3245 3.6567-1.5574l.6803-.6803-4.7622-4.7622Zm.4252 5.0757a3.3872 3.3872 0 0 1-.671-.0677 3.3835 3.3835 0 0 1-.0677-.671c0-.441.087-.9755.4012-1.5281l1.8656 1.8656c-.5526.3142-1.087.4012-1.5281.4012Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuDeploy'
);
